import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.min.css";

import Swiper, { Scrollbar } from "swiper";

document.body.addEventListener("click", function (e) {
  const parent = e.target.parentNode;
  const parentParent = parent.parentNode;
  if (e.target && (e.target.matches(".person-link") || e.target.matches(".person") || parent.matches(".person") || parentParent.matches(".person"))) {
    e.preventDefault();
    const id = e.target.closest(".person").dataset.id;
    const content = document.getElementById(id);
    parentParent.append(content.cloneNode(true));
    const glightbox = GLightbox({
      openEffect: "zoom",
      closeEffect: "fade",
      cssEfects: {
        fade: { in: "fadeIn", out: "fadeOut" },
        zoom: { in: "zoomIn", out: "zoomOut" },
      },
      elements: [
        {
          content,
        },
      ],
    });
    glightbox.open();
  }
  return false;
});

let swiperPeople;

const swiperParent = document.querySelector(".people");

if (swiperParent) {
  const swiperWrapper = document.querySelector(".people .people-wrapper");
  const swiperItems = document.querySelectorAll(".people .person");

  function initSwiper() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 768 && swiperPeople === undefined) {
      swiperParent.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      swiperItems.forEach((e) => e.classList.add("swiper-slide"));

      const swiperPeople = new Swiper(".people.swiper", {
        modules: [Scrollbar],
        touchRatio: 0.2,
        spaceBetween: 10,
        slidesPerView: "auto",
        direction: "horizontal",
        scrollbar: {
          el: ".people-scrollbar",
          draggable: true,
        },
      });
    } else if (screenWidth >= 768 && swiperPeople !== undefined) {
      swiperPeople.destroy();
      swiperPeople = undefined;
      swiperParent.classList.remove("swiper");
      swiperWrapper.removeAttribute("style");
      swiperWrapper.classList.remove("swiper-wrapper");

      swiperItems.forEach((e) => e.classList.remove("swiper-slide"));
    }
  }

  initSwiper();

  window.addEventListener(
    "resize",
    function (event) {
      initSwiper();
    },
    true
  );
}
